import { render } from "./ModalAiProofreader.vue?vue&type=template&id=2348df13&ts=true&lang=pug"
import script from "./ModalAiProofreader.vue?vue&type=script&lang=ts"
export * from "./ModalAiProofreader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__